<template>
  <div>
    <currentpage :page="'ARTICLES ABOUT HEALTHY LIVING'"></currentpage>
    <section id="articles" class="mt-5">
      <b-container class="mb-5">
        <b-row>
          <b-col md="4" v-for="article in articles" :key="article.id">
            <b-card
              :title="article.title"
              :img-src="article.image"
              img-alt="Image"
              img-top
              tag="article"
              style="max-width: 20rem;"
              class="mb-2"
            >
              <p>{{ article.synopsis }}</p>

              <b-button :to="'/articles/'+article.slug" variant="primary">Read More</b-button>
            </b-card>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import articles from '../articles'
export default {
  data: function () {
    return {
      articles: articles
    }
  }
}
</script>

<style>
</style>
